import debounce from './debounce';
import mitt from 'mitt';

export default class ResizeObserver {
  constructor({ debounce = 300 } = {}) {
    this.debounce = debounce;
    this.initialized = false;
    this.observer = mitt();
    this.ticking = false;

    this.onResize = this.onResize.bind(this);
    this.update = this.update.bind(this);
  }

  requestTick() {
    if (!this.ticking) {
      requestAnimationFrame(this.update);
      this.ticking = true;
    }
  }

  onResize() {
    this.requestTick();
  }

  update() {
    this.observer.emit('resize');
    this.ticking = false;
  }

  add(callback) {
    if (!this.initialized) {
      window.addEventListener(
        'resize',
        debounce(this.onResize, this.debounce),
        false
      );
      this.initialized = true;
    }

    this.observer.on('resize', callback);

    const remove = () => this.remove(callback);
    return { remove };
  }

  remove(callback) {
    this.observer.off('resize', callback);
  }
}



// WEBPACK FOOTER //
// ./utils/resize-observer.js